/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { SceneViewDTO } from '../models/SceneViewDTO';
import type { TemplatePresetCreateDTO } from '../models/TemplatePresetCreateDTO';
import type { TemplatePresetEditDTO } from '../models/TemplatePresetEditDTO';
import type { TemplatePresetViewDTO } from '../models/TemplatePresetViewDTO';
import type { TemplatePresetViewDTOODataListResponse } from '../models/TemplatePresetViewDTOODataListResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class TemplatePresetsService {

    /**
     * @param clientId 
     * @param top The max number of records.
     * @param skip The number of records to skip.
     * @param filter A function that must evaluate to true for a record to be returned.
     * @param select Specifies a subset of properties to return. Use a comma separated list.
     * @param orderby Determines what values are used to order a collection of records.
     * @param expand Use to add related query data.
     * @param count Include the overall count
     * @returns TemplatePresetViewDTOODataListResponse Success
     * @throws ApiError
     */
    public static getBackendv2Templatepreset(
clientId?: number,
top?: string,
skip?: string,
filter?: string,
select?: string,
orderby?: string,
expand?: string,
count?: string,
): CancelablePromise<TemplatePresetViewDTOODataListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/backendv2/templatepreset',
            query: {
                'clientId': clientId,
                '$top': top,
                '$skip': skip,
                '$filter': filter,
                '$select': select,
                '$orderby': orderby,
                '$expand': expand,
                '$count': count,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns TemplatePresetViewDTO Success
     * @throws ApiError
     */
    public static postBackendv2Templatepreset(
requestBody?: TemplatePresetCreateDTO,
): CancelablePromise<TemplatePresetViewDTO> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/backendv2/templatepreset',
            body: requestBody,
            mediaType: 'application/json;odata.metadata=minimal;odata.streaming=true',
        });
    }

    /**
     * @param key 
     * @param top The max number of records.
     * @param skip The number of records to skip.
     * @param filter A function that must evaluate to true for a record to be returned.
     * @param select Specifies a subset of properties to return. Use a comma separated list.
     * @param orderby Determines what values are used to order a collection of records.
     * @param expand Use to add related query data.
     * @param count Include the overall count
     * @returns TemplatePresetViewDTO Success
     * @throws ApiError
     */
    public static getBackendv2Templatepreset1(
key: number,
top?: string,
skip?: string,
filter?: string,
select?: string,
orderby?: string,
expand?: string,
count?: string,
): CancelablePromise<TemplatePresetViewDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/backendv2/templatepreset/{key}',
            path: {
                'key': key,
            },
            query: {
                '$top': top,
                '$skip': skip,
                '$filter': filter,
                '$select': select,
                '$orderby': orderby,
                '$expand': expand,
                '$count': count,
            },
        });
    }

    /**
     * @param key 
     * @param requestBody 
     * @returns SceneViewDTO Success
     * @throws ApiError
     */
    public static putBackendv2Templatepreset(
key: number,
requestBody?: TemplatePresetEditDTO,
): CancelablePromise<SceneViewDTO> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/backendv2/templatepreset/{key}',
            path: {
                'key': key,
            },
            body: requestBody,
            mediaType: 'application/json;odata.metadata=minimal;odata.streaming=true',
        });
    }

    /**
     * @param key 
     * @returns any Success
     * @throws ApiError
     */
    public static deleteBackendv2Templatepreset(
key: number,
): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/backendv2/templatepreset/{key}',
            path: {
                'key': key,
            },
        });
    }

}
